import type {BigcommerceCurrency} from "../@types/BCCurrency";
import {API} from "./API";
import {get} from "svelte/store";
import {uuid} from "../store/store";


export interface BCRatesResponse {
    success: boolean;
    rates: BigcommerceCurrency[]
}
export const BCRates = {
    get: () => {
        return API.get<BCRatesResponse>({
            url: `https://api.fastsimon.com/bigcommerce/get_currencies?uuid=${get(uuid)}`,
        });
    }
}